/** @see common/enums/bi/EventTypeEnum.php */
// Список внутренних событий маркетинга системы
export const MarketingEventTypeEnum = {
    addToCart: 1,
    purchase: 2,
    viewProductCard: 3,
    removeFromCart: 4,
    beginCheckout: 5,
    addPaymentInfo: 6,
    call: 8,
    viewItemList: 9,
    selectItem: 10,
    viewCart: 11,
    addShippingInfo: 12,
    refund: 13,
    addToWishlist: 14,
    addToCompare: 15,
}